<div id="personalize-page" class="container">
	<acc-common-personalize [mainCartId]="cartId" *ngIf="cartId" [onFileAdded]="fileAdded.asObservable()" (onClose)="close()" (onShowSelectFile)="showSelectFile()" [quoteId]="quoteId"></acc-common-personalize>
</div>